import type { DesignTokenType } from './types';

// Style properties only. Business/content fields are deliberately excluded.
export const DESIGN_TOKEN_PROPERTY_CONFIG: Readonly<Record<string, readonly DesignTokenType[]>> = {
	color: ['color'],
	backgroundColor: ['color'],
	borderColor: ['color'],
	borderTopColor: ['color'],
	borderRightColor: ['color'],
	borderBottomColor: ['color'],
	borderLeftColor: ['color'],
	outlineColor: ['color'],
	textDecorationColor: ['color'],
	fill: ['color'],
	stroke: ['color'],
	strokeWidth: ['dimension', 'number'],
	fontFamily: ['fontFamily'],
	fontWeight: ['number'],
	fontSize: ['dimension'],
	lineHeight: ['dimension', 'number'],
	letterSpacing: ['dimension'],
	wordSpacing: ['dimension'],
	opacity: ['number'],
	zIndex: ['number'],
	flexGrow: ['number'],
	flexShrink: ['number'],
	order: ['number'],
	width: ['dimension'],
	height: ['dimension'],
	minWidth: ['dimension'],
	maxWidth: ['dimension'],
	minHeight: ['dimension'],
	maxHeight: ['dimension'],
	top: ['dimension'],
	right: ['dimension'],
	bottom: ['dimension'],
	left: ['dimension'],
	gap: ['dimension'],
	rowGap: ['dimension'],
	columnGap: ['dimension'],
	padding: ['dimension'],
	paddingTop: ['dimension'],
	paddingRight: ['dimension'],
	paddingBottom: ['dimension'],
	paddingLeft: ['dimension'],
	margin: ['dimension'],
	marginTop: ['dimension'],
	marginRight: ['dimension'],
	marginBottom: ['dimension'],
	marginLeft: ['dimension'],
	borderWidth: ['dimension'],
	borderTopWidth: ['dimension'],
	borderRightWidth: ['dimension'],
	borderBottomWidth: ['dimension'],
	borderLeftWidth: ['dimension'],
	borderRadius: ['dimension'],
	borderTopLeftRadius: ['dimension'],
	borderTopRightRadius: ['dimension'],
	borderBottomLeftRadius: ['dimension'],
	borderBottomRightRadius: ['dimension'],
	outlineWidth: ['dimension'],
	outlineOffset: ['dimension'],
	textIndent: ['dimension'],
	flexBasis: ['dimension'],
};

export function isDesignTokenTypeCompatible(property: string, type: DesignTokenType): boolean {
	return DESIGN_TOKEN_PROPERTY_CONFIG[property]?.includes(type) ?? false;
}
